function TrackUTMParams(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const domainsToDecorate = (window as any).domainsToDecorate || [
        'legalsuper.com.au', // add or remove domains (without https or trailing slash)
        'inte.legalsuper.com.au',
        'legalsuper-mcx-uat.np.linkgroup.com',
        'member.legalsuper.com.au',
        // for development purpose
        'localhost',
        'legalsuper-optimizely.luminary.space'
    ];

    // check if any utm param exists in the url
    const isUTMParamExists = (): boolean => {
        const urlParams = new URLSearchParams(window.location.search);
        const paramsKeys = Array.from(urlParams.keys());

        return paramsKeys.some((param: string) => {
            return param.includes('utm_') || param.includes('ls_');
        });
    };

    const getUTMParams = (): Record<string, string> => {
        const urlParams = new URLSearchParams(window.location.search);
        const params: Record<string, string> = {};

        urlParams.forEach((value, key) => {
            if (key.includes('utm_') || key.includes('ls_')) {
                params[key] = value;
            }
        });

        return params;
    };

    const hasDomainToWatch = (link: string): boolean => {
        try {
            const parsedLink = new URL(link);
            const { hostname } = parsedLink;

            return domainsToDecorate.some((domain: string) => {
                return hostname.includes(domain);
            });
        } catch (error) {
            return false;
        }
    };

    // decorates the URL with query params
    const decorateUrl = (urlToDecorate: string, utmParams: Record<string, string>): string => {
        try {
            const parsedURL = new URL(urlToDecorate);
            const parsedURLParams = new URLSearchParams(parsedURL.search);
            const paramsKeys = Array.from(parsedURLParams.keys());

            const hasExistingUTM = paramsKeys.some(param => {
                return param.includes('utm_');
            });

            if (!hasExistingUTM) {
                // Append new UTM parameters only if none exist
                for (const [key, value] of Object.entries(utmParams)) {
                    parsedURLParams.set(key, value);
                }

                // Reconstruct the URL with the updated query parameters
                parsedURL.search = parsedURLParams.toString();

                // Handle hashtags
                if (parsedURL.hash) {
                    return parsedURL.href.replace(parsedURL.hash, '') + parsedURL.hash;
                }

                return parsedURL.href;
            }

            return urlToDecorate;
        } catch (error) {
            return urlToDecorate;
        }
    };

    if (isUTMParamExists()) {
        const utmParams = getUTMParams();

        // get all links on the page
        const links = document.querySelectorAll('a');

        if (links?.length) {
            links.forEach(link => {
                const { href } = link as HTMLAnchorElement;

                if (hasDomainToWatch(href)) {
                    link.href = decorateUrl(href, utmParams);
                }
            });
        }
    }
}

/**
 * TODO: better to adjust LINK component on react for a better maintainable code
 */
const contentObserver = new MutationObserver(mutationsList => {
    for (const mutation of mutationsList) {
        // console.debug(mutation);
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            TrackUTMParams();
        }
    }
});

document.addEventListener('DOMContentLoaded', () => {
    // initiate UTM tracker
    TrackUTMParams();

    // to inititate UTM tracker to any react sections on page
    contentObserver.observe(document.body, { childList: true, subtree: true });
});


